import axios from 'axios';
import Qs from 'qs';
import notAuthorized from './interceptors/notAuthorized';
import appconf from "../appconf";

const apiUrl = appconf.api.URL;

const instance = axios.create({
  baseURL: apiUrl,
  paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: 'brackets' }),

});

instance.interceptors.response.use(...notAuthorized);

export default instance;
